import { GuardTourState, GuardTour, GuardTourType } from "./types";

export function getDefaultState(): GuardTourState {
    return {
        guardTours: Array<GuardTour>(),
        waypointMarkerPosition: null,
        creatingWaypoint: false,
        itemToAdd: null,
        currentGuardTour: null,
        showTour: true,
        loadItemsFromMap: false,
        mapItemList: [],
        selectedAreaId: 0,
        filterTourTypeId: GuardTourType.Guard,
        assessmentTours: Array<GuardTour>(),
    }
}